import React                 from 'react';
import styled                from 'styled-components';
import { Grid, GridSpacing } from '@material-ui/core';
import { ICardAd }           from '@typings/nationalAdManagement';
import { AdItem }            from './AdItem';

interface IProps {
  adsData    : ICardAd[];
  spacing    : GridSpacing;
  onEditAd   : (id: string) => void;
  onDeleteAd : (id: string) => void;
}

const Wrapper = styled.div`
  max-width : 1515px;
  margin    : 0 auto;
  padding   : 40px 20px 40px;
`;

export const AdsListWrapper: React.FC<IProps> = ({
  adsData = [],
  spacing,
  onEditAd,
  onDeleteAd,
}) => (
  <Wrapper>
    <Grid container spacing={spacing}>
      {adsData.map((adData) => (
        <Grid
          item
          xs  = {12}
          sm  = {6}
          md  = {4}
          lg  = {3}
          key = {adData.id}
        >
          <AdItem
            adData     = {adData}
            onEditAd   = {onEditAd}
            onDeleteAd = {onDeleteAd}
            withActions
            withDetails
          />
        </Grid>
      ))}
    </Grid>
  </Wrapper>
);
